export const productTypes = [
  { type: 'โทรศัพท์มือถือ' },
  { type: 'แท็บเล็ต' },
  { type: 'ตู้เงินดี' },
  { type: 'สินเชื่อหมุนเวียน' },
  { type: 'เครื่องใช้ไฟฟ้า' },
];

export enum productType {
  MOBILE = 'โทรศัพท์มือถือ',
  ELECTRICAL_APPLIIANCE = 'เครื่องใช้ไฟฟ้า',
  LOAN_FRESH = 'สินเชื่อหมุนเวียน',
  AIR_CONDITIONER = 'แอร์',
  FRIDGE = 'ตู้เย็น',
  MINI_ATM = 'ตู้เงินดี',
  TABLET = 'แท็บเล็ต',
}
export enum platform {
  CJ = 'CJ',
  TD = 'TD',
  CJX = 'CJx',
}

export enum productTypeStatus {
  YES = 'Y',
}
